import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHAgrupamientoUpd } from "services/services-mia/programa-salud/personal/RNHAgrupamientoUpd";
import { RNHAgrupamientoGet } from "services/services-mia/programa-salud/personal/RNHAgrupamientoGet";

export default function UpdateModal({ row, closeModal, updateList }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const [data, setData] = useState();
  const [inRequest, setInRequest] = useState(false);
  const formikRef = useRef();

  // Se relee el registro aunque la fila ya traiga cod y nombre: lo que importa es la
  // VERSION. Si alguien mas lo modifico desde que se cargo la grilla, la de la fila
  // quedo vieja y el Upd lo rechaza.
  const getAgrupamientoData = async () => {
    setInRequest(true);
    const { data: result } = await RNHAgrupamientoGet(credentials, { id: row.id });
    const encontrado = Array.isArray(result)
      ? result.find((c) => String(c.rnhAgrupamientoId) === String(row.id))
      : null;
    setInRequest(false);

    if (!encontrado) {
      setSnackBarInfo({
        message: "No se pudo cargar el agrupamiento seleccionado.",
        severity: "error",
        open: true,
      });
      closeModal();
      return;
    }

    formikRef.current.setValues({
      nombre: encontrado.rnhAgrupamientoNombre ?? "",
      cod: encontrado.rnhAgrupamientoCod ?? "",
    }, false);
    setData(encontrado);
  };

  const guardarAgrupamiento = async (values) => {
    setInRequest(true);
    const response = await RNHAgrupamientoUpd(credentials, {
      // Lo recien leido manda; la fila de la grilla es el respaldo por si el Get fallo.
      id: data?.rnhAgrupamientoId ?? row.id,
      cod: values.cod,
      nombre: values.nombre,
      version: data?.rnhAgrupamientoVersion ?? row.version,
    });

    setInRequest(false);
    if (response.ok) {
      setSnackBarInfo({
        message: "Agrupamiento modificado correctamente",
        severity: "success",
        open: true,
      });

      formikRef.current.resetForm();
      updateList();
      closeModal();
    }
  };

  useEffect(() => {
    getAgrupamientoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        nombre: row?.nombre ?? "",
        cod: row?.cod ?? "",
      }}
      validationSchema={yup.object({
        nombre: yup
          .string()
          .max(LARGO.nombre, mensajeLargo(LARGO.nombre))
          .required("Debe ingresar un nombre"),
        cod: yup
          .string()
          .max(LARGO.cod, mensajeLargo(LARGO.cod))
          .required("Debe ingresar un código"),
      })}
      onSubmit={(values) => {
        guardarAgrupamiento(values);
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={2}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
            }}
          >
            <Grid item xs={4}>
              <FormikTextInput
                fullWidth={true}
                name="cod"
                labelText="Código"
                  inputProps={{ maxLength: LARGO.cod }}
              />
            </Grid>
            <Grid item xs={8}>
              <FormikTextInput
                fullWidth={true}
                name="nombre"
                labelText="Nombre"
                  inputProps={{ maxLength: LARGO.nombre }}
              />
            </Grid>
          </Grid>
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Modificar" }}
            onCloseModal={closeModal}
          />
          {(inRequest) && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
